import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ExtractResourceContent(
    $customerId: ID!
    $workspaceId: ID!
    $input: ResourceDetailsInput!
    $withImages: Boolean
  ) {
    extractResourceContent(
      customerId: $customerId
      workspaceId: $workspaceId
      input: $input
      withImages: $withImages
    ) {
      id
      status
    }
  }
`;

export const extractResourceContent = async ({
  customerId,
  workspaceId,
  input,
  withImages = false,
}) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: { customerId, workspaceId, input, withImages },
  });

  return getSingleProp(result.data);
};
